import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=6e8e5db3&"
import script from "./Image.vue?vue&type=script&lang=ts&"
export * from "./Image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports